import { render, staticRenderFns } from "./MembersTransferConfirmationStatusList.vue?vue&type=template&id=6d156512"
import script from "./MembersTransferConfirmationStatusList.vue?vue&type=script&lang=js"
export * from "./MembersTransferConfirmationStatusList.vue?vue&type=script&lang=js"
import style0 from "./MembersTransferConfirmationStatusList.vue?vue&type=style&index=0&id=6d156512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports